import { apiGet, apiPut } from '../../framework/client';
import { ERROR_API_CALL_FAILED } from '../../../common/framework/constants';

export async function getGSGApiKey(customerId: string): Promise<{ apiKey: string }> {
    const response = await apiGet(`/api/gsg/api-key/${customerId}`);

    if (response.status === 200) {
        return (await response.json()) as any;
    } else {
        throw new Error(ERROR_API_CALL_FAILED);
    }
}

export async function saveGSGApiKey(customerId: string, gsgApiKey: string): Promise<{ success: number }> {
    const response = await apiPut(`/api/gsg/api-key/${customerId}`, { gsgApiKey });

    if (response.status === 200) {
        return (await response.json()) as any;
    } else {
        throw new Error(ERROR_API_CALL_FAILED);
    }
}
